<template>
    <div class="proposeList" :style="jdshow ? 'overflow: hidden;' : ''">
        <!-- <div class="header">
            <img src="@/assets/new/fan.png"  @click="goHome" alt="">
            <span>我的奖励</span>
        </div> -->

        <div class="jiefix">
            <div class="fone">
                <img src="@/assets/c/img_jlbj.png" class="bg" alt="" />
                <div @click="setPopup()" class="guiview">
                    <!-- <img
                        src="@/assets/c/icon_jltime.png"
                        class="icon_gz"
                        alt=""
                    /> -->
                    <span class="guiname"> {{ $t("new.lingjilu") }}</span>
                </div>
            </div>
        </div>
        <div class="tuview">
            <img src="@/assets/c/img_bts.png" class="touhead" alt="" />
        </div>
        <div class="kone">
            <img src="@/assets/c/img_ztbj.png" class="bg" alt="" />
            <div class="koneview">
                <div class="khead">
                    <div class="kleft">
                        <span class="lname">{{ $t("new.jinlin") }}</span>
                        <span class="lmiao">{{ today }}</span>
                    </div>
                    <div class="kleft">
                        <span class="lname">{{ $t("new.leilin") }}</span>
                        <span class="lmiao">{{ total }}</span>
                    </div>
                </div>
                <div class="kbot">
                    <div v-if="time > 0">
                        <Countdown :time="time"></Countdown>
                    </div>
                </div>
            </div>
        </div>
        <div class="lingview" @click="buy">
            {{ $t("new.lqu") }}
        </div>
        <div class="guiviewshuo">
            <img src="@/assets/c/img_bk.png" class="bg" alt="" />
            <div class="guiitem">
                <span class="gname">{{ $t("new.gui") }}</span>
                <span
                    class="gmiao"
                    v-html="kongtouRule"
                    style="
                        overflow-y: scroll;
                        height: 280px;
                        word-wrap: break-word;
                    "
                ></span>
            </div>
        </div>
        <div class="fanview" @click="$router.go(-1)">
            <img src="@/assets/c/fan.png" class="bg" alt="" />
        </div>

        <!-- 领取记录弹窗等 -->
        <van-popup :close-on-click-overlay="false"
            v-model="jdshow"
            position="center"
            :style="{ background: 'none' }"
            :overlay-style="{ background: 'rgba(0, 0, 0, 0.7)' }"
        >
            <div class="popview van-jdpop animate__animated animate__zoomIn">
                <img src="@/assets/c/pbtntwo.png" class="bg" alt="" />
                <div class="jdview">
                    <div class="jshead">
                        <img src="@/assets/c/pbtnone.png" class="bg" alt="" />
                        <div class="jheadview">
                            {{ $t("new.lingjilu") }}
                        </div>
                    </div>
                    <div class="tview oneview">
                        <div class="tone">{{ $t("new.shijian") }}</div>
                        <div class="tthree">{{ $t("new.shuliang") }}</div>
                    </div>
                    <div
                        class="tview"
                        style="overflow-y: scroll; height: 280px"
                    >
                        <div
                            class="tlist"
                            v-for="(item, index) in log"
                            :key="index"
                        >
                            <span class="tone">
                                {{ item.created_at }}
                            </span>
                            <span class="tthree">
                                {{ item.value }}
                            </span>
                        </div>
                    </div>
                    <div class="jsheadbot" @click.stop="setPopup">
                        <img src="@/assets/c/pbtnthree.png" class="bg" alt="" />
                        <div class="jheadview">
                            {{ $t("new.queren") }}
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { showToast, useNumberAnimation } from "@/libs/util.js";
import Countdown from "@/view/components/Countdown.vue";
import { ajaxData } from "@/api/ajax";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        Countdown,
    },
    data() {
        return {
            rule: "",
            todayBase: 0,
            today: 0,
            totalBase: 0,
            total: 0,
            airdrop: [],
            jdshow: false,
            lqList: [],
            time: 0,
            log: [],
        };
    },
    created() {
        let vm = this;
        vm.getDatas();
    },
    computed: mapState(["kongtouRule"]),
    watch: {
        todayBase(newVal) {
            if (newVal > 0) {
                useNumberAnimation(newVal, (num) => {
                    this.today = num?.toFixed(2);
                });
            }
        },
        totalBase(newVal) {
            if (newVal > 0) {
                useNumberAnimation(newVal, (num) => {
                    this.total = num?.toFixed(2);
                });
            }
        },
    },
    methods: {
        ...mapActions['setKongtouRule'],
        setPopup() {
            this.jdshow = !this.jdshow;
            if (this.jdshow) {
                document.body.style.overflow = "hidden"; // 禁止滚动
            } else {
                document.body.style.overflow = "";
            }
        },
        buy() {
            let vm = this;
            ajaxData("/airdrop/buy", {}).then((response) => {
                if (response.code == 0) {
                    showToast(this.$t("pickup_success"));
                    vm.getDatas();
                    console.log(response);
                }else {
                    showToast(response.msg);
                }
            });
        },
        getDatas() {
            let vm = this;
            ajaxData("/airdrop", {}).then((response) => {
                vm.todayBase = response.data.today;
                vm.totalBase = response.data.total;
                vm.airdrop = response.data.airdrop;
                vm.time = response.data.djs;
                vm.log = response.data.log;
                console.log(response);
                // vm.rule = response.data.rule;
                this.$store.dispatch('setKongtouRule',response.data.rule);

            });
        },
        goHome() {
            this.$router.go(-1);
        },
    },
};
</script>


<style scoped lang="less">
p {
    margin: 0;
    padding: 0;
}

.proposeList {
    width: 100%;
    height: 100%;
    background: rgba(19, 19, 19, 1);
    padding-bottom: 30px;
    .jiefix {
        position: fixed;
        right: 0;
        top: 15%;
        display: flex;
        flex-direction: column;
        z-index: 10;
        .fone {
            position: relative;
            width: 24px;
            height: 84px;
            margin-bottom: 10px;
            margin-right: 5px;
            .guiview {
                position: relative;
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .icon_gz {
                    width: 16px;
                    height: 16px;
                    margin-bottom: 3px;
                }
                .guiname {
                    // color: #ffffff;
                    color: #26e7fe;
                    font-weight: 500;
                    font-size: 10px;
                    padding-right: 2px;
                    padding-top: 3px;
                    writing-mode: vertical-rl;
                    letter-spacing: 5px;
                }
            }
        }
    }
    .kone {
        position: relative;
        height: 414px;
        width: 100%;
        .koneview {
            position: relative;
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 100%;
            .khead {
                height: 52px;
                // width: 100%;
                margin: 0 45px;
                padding-top: 13px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .kleft {
                height: 100%;
                width: 42%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding-top: 3px;
                .lname {
                    font-weight: 500;
                    font-size: 10px;
                    color: #cccccc;
                    line-height: 13px;
                }
                .lmiao {
                    font-weight: 500;
                    font-size: 14px;
                    color: #26e7fe;
                }
            }
        }
        .kbot {
            height: 35px;
            // background-color: #eee;
            margin-bottom: 19px;
            margin: auto 130px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 18px;
            color: #1a1a1a;
            position: relative;
        }
    }
    .tuview {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .touhead {
        width: 328px;
        object-fit: cover;
        position: relative;
        margin: 20px auto;
    }
    .lingview {
        margin: 0px 30px 20px;
        height: 44px;
        background: #26e7fe;
        border-radius: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        font-size: 14px;
        color: #1a1a1a;
    }
    .guiviewshuo {
        position: relative;
        margin: 0 17px;
        height: 362px;
        .guiitem {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding: 20px 30px;
        }
        .gname {
            display: block;
            text-align: center;
            margin: 10px 0;
            font-weight: 500;
            font-size: 15px;
            color: #26e7fe;
        }
        .gmiao {
            font-weight: 500;
            font-size: 12px;
            color: #26e7fe;
        }
    }
    .header {
        height: 50px;
        // margin-bottom: 12px;
        // padding: 40px 12px 0 12px;
        padding: 6px;
        box-sizing: border-box;
        background: rgba(52, 56, 75, 1);
        display: flex;
        align-items: center;
        justify-content: center;
        position: sticky;
        width: 100%;
        z-index: 10;
        top: 0;
        img {
            width: 55px;
            height: 55px;
            position: absolute;
            left: 10px;
        }

        span {
            font-weight: bold;
            font-size: 18px;
            color: #ffffff;
        }
    }

    .van-jdpop {
        position: relative;
        padding: 0;
        height: 427px;
        width: 330px;
        background: transparent !important;

        .jdview {
            position: relative;
            width: 100%;
            height: 100%;
            padding: 15px;
            display: flex;
            flex-direction: column;
            .jshead {
                position: relative;
                width: 103px;
                height: 37px;
                margin: 15px auto;
                .jheadview {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    color: #00ffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .tview {
                display: flex;
                flex-direction: column;
                // align-items: center;
                width: 100%;

                .tone {
                    width: 80%;
                    font-weight: 500;
                    font-size: 12px;
                    color: #26e7fe;
                }
                .ttwo {
                    font-weight: 500;
                    font-size: 12px;
                    color: #26e7fe;
                    display: block;
                    width: 20%;
                    text-align: center;
                }
                .tthree {
                    font-weight: 500;
                    font-size: 12px;
                    color: #26e7fe;
                    display: block;
                    width: 20%;
                    text-align: right;
                }
                .tlist {
                    padding: 15px;
                    background: #006c83;
                    border-radius: 10px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 96%;
                    margin: 0 auto 10px;

                    .tleft {
                        font-weight: 500;
                        font-size: 12px;
                        color: #ffffff;
                    }
                }
            }
            .jsheadbot {
                width: 150px;
                height: 54px;
                position: relative;
                margin: auto auto 20px;
                .jheadview {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    font-weight: bold;
                    font-size: 14px;
                    color: #00ffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
            .oneview {
                padding: 0 15px;
                margin-bottom: 15px;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
        }
    }

    .mhead {
        // position: relative;
        // top: 50px;
    }
}
</style>
